import React from 'react';
import { hydrate, render } from 'react-dom';
import App from "./App";
import {getDocument, getWindow } from "../Helpers/browsers";

getDocument().then(document => {
    let root = document.getElementById('livestream-page');

    if (root) {
      hydrate(<App previews={window.previews} />, root);
    }
});